<template>
    <v-row no-gutters>
      <v-col cols="12" class="mt-2 hidden-sm-and-down">
        <v-tabs
          v-model="tab"
          height="32px"
          class="mt-4"
        >
          <v-chip small class="primary ma-2" label>
            <strong>{{project}}</strong>
          </v-chip>

          <v-tabs-slider color="yellow"></v-tabs-slider>
          
          <v-tab class="ml-2" key="Submissions" v-if="ispassword">
            Submissions
          </v-tab>
          <v-tab key="Files">
            Files
          </v-tab>
          <v-tab key="Search">
            Search
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item v-if="ispassword" key="Submissions">
            <v-card flat>
              <v-card-text class="pa-0">
                <Submissions :project="project" />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="Files">
            <v-card flat>
              <v-card-text class="pa-0">
                <FileTree :key="project_path" :project="project" :project_path="project_path || project" :set_project_path="set_project_path" :show_tab="show_tab" :avail_height="avail_height" />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="Search">
            <v-card flat>
              <v-card-text>
                <FileSearch :project="project" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
      <v-col cols="12" class="mt-2 hidden-md-and-up">
        <v-chip small class="primary mx-2 mt-4 mb-2" label>
          <strong>{{project}}</strong>
        </v-chip>
        <!--v-card flat>
          <v-card-text class="pa-0">
            <Submissions :project="project" />
          </v-card-text>
        </v-card-->

        <v-tabs
          v-model="mob_tab"
          height="32px"
          class="mt-0"
        >
          <v-tabs-slider color="yellow"></v-tabs-slider>
          
          <v-tab class="ml-2" key="Submissions" v-if="ispassword">
            Submissions
          </v-tab>
          <v-tab key="Files">
            Files
          </v-tab>
        </v-tabs>
        
        <v-tabs-items v-model="mob_tab">
          <v-tab-item v-if="ispassword" key="Submissions">
            <v-card flat>
              <v-card-text class="pa-0">
                <Submissions :project="project" />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item key="Files">
            <v-card flat>
              <v-card-text class="pa-0">
                <FileTree :key="project_path" :project="project" :project_path="project_path || project" :set_project_path="set_project_path" :show_tab="show_tab" :avail_height="avail_height" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
</template>

<script>
import Submissions from './Submissions.vue';
import FileTree from './NewFileTree.vue';
import FileSearch from './FileSearch.vue';

export default {
  name: "ProjectView",
  components: { Submissions, FileTree, FileSearch },
  data() {
    return {
      avail_height: 520,
      project: null,
      project_storage: null,
      tab: null,
      mob_tab: null,
      project_path: null,
      ispassword: false
    }
  },
  methods: {
    show_tab(tab_id) {
      this.tab = tab_id;
    },
    set_project_path(project_path){
      if (project_path){
        this.project_path = project_path;
      }else{
        this.project_path = null;
      }
    }
  },
  computed : {
    userLoggedIn : function() { return this.$store.getters.userLoggedIn}
  },
  created () {
    this.avail_height = window.innerHeight;

    if (this.userLoggedIn.ispassword){
      this.ispassword = true;
    }

    this.project = this.$route.params.name;
    this.project_storage = this.$route.query.storage;
    let tab_id = parseInt(this.$route.query.tab_id);
    if (tab_id){
      this.show_tab(tab_id);
    }
  }
}
</script>
<style>

</style>